import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';

import { routes } from 'constants/routes';
import { useRedirect } from 'hooks/useRedirect';
import { userFetch } from 'store/features';
import { UserType } from 'types';

interface AuthorizedSceneProps extends RouteProps {
  authorizedUsers: Array<UserType>;
}

export const AuthorizedScene = ({
  authorizedUsers,
  ...props
}: AuthorizedSceneProps): JSX.Element => {
  const userType = useSelector(userFetch.selectors.getUserType);

  /**
   * When the user is ADMIN can have a valid userType and not have userData
   */
  const hasData = !!useSelector(userFetch.selectors.getData);

  const newLocation = useRedirect(routes.startUpRoute, true);

  const isNotAuthorizeduser = !authorizedUsers.includes(userType || 'USER');
  if (isNotAuthorizeduser || !hasData) return <Redirect to={newLocation} />;

  return <Route {...props} />;
};
